import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type ProfileInfoFragment = {
	__typename: 'Profile';
	displayName: string;
	firstName: string;
	lastName: string;
	location?: string | null;
	country: any;
	bio?: string | null;
	avatarUrl?: string | null;
	isComplete: boolean;
	ownedByUser: boolean;
	profileUrl: string;
	profileType: Types.ProfileType;
	contentPersonId?: string | null;
	id: string;
	externalUrls?: Array<{
		__typename?: 'ProfileSpecificLink';
		type: Types.ProfileSpecificLinkType;
		name?: string | null;
		url: string;
	}> | null;
};

export type ProfileInfoV2Fragment = {
	__typename: 'ProfileV2';
	id: string;
	content: {
		__typename?: 'ProfileContent';
		displayName: string;
		location?: string | null;
		bio?: string | null;
		avatarUrl?: string | null;
		ownedByUser: boolean;
		profileUrl: string;
		profileType: Types.ProfileType;
		externalUrls?: Array<{
			__typename?: 'ProfileSpecificLink';
			type: Types.ProfileSpecificLinkType;
			name?: string | null;
			url: string;
		}> | null;
	};
};

export const ProfileInfoFragmentDoc = gql`
	fragment ProfileInfo on Profile {
		__typename
		id: uuid
		displayName
		firstName
		lastName
		location
		country
		bio
		avatarUrl
		isComplete
		externalUrls {
			type
			name
			url
		}
		ownedByUser
		profileUrl
		profileType
		contentPersonId
	}
`;
export const ProfileInfoV2FragmentDoc = gql`
	fragment ProfileInfoV2 on ProfileV2 {
		__typename
		id
		content(country: $country, language: $language) {
			displayName
			location
			bio
			avatarUrl
			externalUrls {
				type
				name
				url
			}
			ownedByUser
			profileUrl
			profileType
		}
	}
`;
